import React, { type FC, type InputHTMLAttributes, LegacyRef } from 'react'

import s from './codeInput.module.scss'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    inputRef: LegacyRef<HTMLInputElement>
}

export const CodeInputNew: FC<Props> = ({ className, inputRef, ...props }: Props) => {

    return (
        <input
            className={s.codeInput}
            ref={inputRef}
            {...props}
        />
    )
}
